import { all, put,call, takeLatest } from 'redux-saga/effects';
import * as Observacao from '~/services/Observacao';
import  * as actionType from './actionType';
import * as actions from './action';
import { getErros } from '~/store/modules/errors/action';

function* loadObservacoesWorker({params}) {
  try {
    const response = yield call(Observacao.load, params);
    yield put(actions.getObservacoes(response));
    yield put(actions.getErros({}));
    yield put(getErros({}));
  } catch (error) {
    if (error.response) {
      yield put(actions.getErros(error.response));
      yield put(getErros(error.response));
    } else if (error.request) {
      yield put(getErros({data: error.message}));
    } else {
      yield put(getErros({data: error.message}));
    }
  }
}

function* loadSelectObservacoesWorker() {
  try {
    const response = yield call(Observacao.select);
    yield put(actions.getSelectObservacoes(response));
    yield put(actions.getErros({}));
    yield put(getErros({}));
  } catch (error) {
    if (error.response) {
      yield put(actions.getErros(error.response));
      yield put(getErros(error.response));
    } else if (error.request) {
      yield put(getErros({ data: error.message }));
    } else {
      yield put(getErros({ data: error.message }));
    }
  }
}

function* showObservacaoWorker({id}) {
  try {
    const response = yield call(Observacao.show, id);
    yield put(actions.getObservacao(response));
    yield put(actions.getErros({}));
    yield put(getErros({}));

  } catch (error) {
    if (error.response) {
      yield put(actions.getErros(error.response));
      yield put(getErros(error.response));
    } else if (error.request) {
      yield put(getErros({data: error.message}));
    } else {
      yield put(getErros({data: error.message}));
    }
  }
}

function* updateObservacaoWorker({ observacao, id}) {
  try {
    const response = yield call(Observacao.update, id, observacao);
    yield put(actions.getObservacao(response));
    yield put(actions.getErros({update:true}));
    yield put(getErros({update:true}));

  } catch (error) {
    if (error.response) {
      yield put(actions.getErros(error.response));
      yield put(getErros(error.response));
    } else if (error.request) {
      yield put(getErros({data: error.message}));
    } else {
      yield put(getErros({data: error.message}));
    }
  }
}

function* storeObservacaoWorker({observacao}) {
  try {
    const response = yield call(Observacao.store, observacao);
    yield put(actions.getObservacao(response));
    yield put(actions.getErros({save:true}));
    yield put(getErros({save:true}));

  } catch (error) {
    if (error.response) {
      yield put(actions.getErros(error.response));
      yield put(getErros(error.response));
    } else if (error.request) {
      yield put(getErros({data: error.message}));
    } else {
      yield put(getErros({data: error.message}));
    }
  }
}

function* removerObservacaoWorker({id}) {
  try {
    yield call(Observacao.destroy, id);
    yield put(actions.getErros({}));
    yield put(getErros({}));

  } catch (error) {
    if (error.response) {
      yield put(actions.getErros(error.response));
      yield put(getErros(error.response));
    } else if (error.request) {
      yield put(getErros({data: error.message}));
    } else {
      yield put(getErros({data: error.message}));
    }
  }
}

function* watcherObservacao() {
  yield takeLatest(actionType.LOAD_OBSERVACOES, loadObservacoesWorker);
  yield takeLatest(actionType.LOAD_SELECT_OBSERVACOES, loadSelectObservacoesWorker);
  yield takeLatest(actionType.STORE_OBSERVACAO, storeObservacaoWorker);
  yield takeLatest(actionType.SHOW_OBSERVACAO, showObservacaoWorker);
  yield takeLatest(actionType.UPDATE_OBSERVACAO, updateObservacaoWorker);
  yield takeLatest(actionType.REMOVER_OBSERVACAO, removerObservacaoWorker);
}

export default function* saga() {
  yield all([watcherObservacao()]);
}
